// extracted by mini-css-extract-plugin
export default {"main":"Timeline_main__TKXKL","heading":"Timeline_heading__zfooA"};